/* Cats Garage — product-gallery.js
   Thumbnail click swaps the main PDP image; "+N" tile reveals hidden thumbs.
   Choosing a variant (cg:variant-change from product-form.js) shows its photo.
   Vanilla JS, loaded with defer. Without JS the featured image simply stays. */
(function () {
  'use strict';

  function revealAll(gallery) {
    gallery.querySelectorAll('[data-thumb][hidden]').forEach(function (thumb) {
      thumb.removeAttribute('hidden');
    });
    var more = gallery.querySelector('[data-thumbs-more]');
    if (more) more.setAttribute('hidden', '');
  }

  function show(gallery, src, alt, activeThumb) {
    var main = gallery.querySelector('[data-main-image]');
    if (!main || !src) return;

    main.removeAttribute('srcset');
    main.src = src;
    if (alt) main.alt = alt;

    gallery.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.classList.toggle('is-active', t === activeThumb);
    });
  }

  document.addEventListener('click', function (event) {
    var more = event.target.closest('[data-thumbs-more]');
    if (more) {
      var galleryEl = more.closest('[data-cg-gallery]');
      if (galleryEl) revealAll(galleryEl);
      return;
    }

    var thumb = event.target.closest('[data-thumb]');
    if (!thumb) return;

    var gallery = thumb.closest('[data-cg-gallery]');
    if (gallery) show(gallery, thumb.getAttribute('data-full'), thumb.getAttribute('data-alt'), thumb);
  });

  document.addEventListener('cg:variant-change', function (event) {
    var variant = event.detail && event.detail.variant;
    var media = variant && variant.featured_media;
    // A variant without its own photo keeps whatever image is showing.
    if (!media) return;

    var scope = event.target.closest ? event.target.closest('[data-cg-pdp]') : null;
    var gallery = (scope || document).querySelector('[data-cg-gallery]');
    if (!gallery) return;

    var thumb = gallery.querySelector('[data-thumb][data-media-id="' + media.id + '"]');
    if (thumb) {
      if (thumb.hidden) revealAll(gallery);
      show(gallery, thumb.getAttribute('data-full'), thumb.getAttribute('data-alt'), thumb);
      return;
    }

    var src = media.preview_image && media.preview_image.src;
    if (src) show(gallery, src, media.alt, null);
  });
})();
